var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "relative my-4 z-10" }, [
    _vm.status === "SUCCESS"
      ? _c("div", { staticClass: "w-full bg-green-100 py-4 px-6 rounded-md" }, [
          _c("span", {
            staticClass:
              "text-xl text-green-600 mr-2 mdi mdi-check-circle-outline",
          }),
          _c("span", [_vm._v(_vm._s(_vm.message))]),
        ])
      : _vm.status === "PENDING"
      ? _c(
          "div",
          { staticClass: "w-full bg-yellow-100 py-4 px-6 rounded-md" },
          [
            _c("span", {
              staticClass:
                "text-xl text-yellow-600 mr-2 mdi mdi-circle-outline",
            }),
            _c("span", [_vm._v(_vm._s(_vm.message))]),
          ]
        )
      : _vm.status === "ERROR"
      ? _c("div", { staticClass: "w-full bg-red-100 py-4 px-6 rounded-md" }, [
          _c("span", {
            staticClass: "text-xl text-red-600 mr-2 mdi mdi-alert-outline",
          }),
          _c("span", [_vm._v(_vm._s(_vm.message))]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }